import { render } from "./successPage.vue?vue&type=template&id=5f08fc92"
import script from "./successPage.vue?vue&type=script&lang=js"
export * from "./successPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__